import { render, staticRenderFns } from "./SubBrandSelector.vue?vue&type=template&id=174bfc8b"
import script from "./SubBrandSelector.vue?vue&type=script&lang=js"
export * from "./SubBrandSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports